declare const document: any;
/**
  * 获取cookie
*/
export function getCookie(name: string): string {
  let namematch;
  namematch = document.cookie.match(RegExp(`(?:^|;)\\s*${name}=([^;]*)`));
  return namematch ? namematch[1] : "";
}
/**
 * 设置cookie
 * @param {string} name 设置的cookie名
 * @param {string} value 设置的cookie值
 * @param {string} domain 设置的cookie的domain，默认为 ""
 * @param {string} path  设置的cookie的路径，默认为 /
 * @param {number} hour 设置的cookie的时间，默认为 8760小时（1年）
*/
export function setCookie(name: string, value: string|number, domain?: string, path: string = "/", hour: number = 8760): void {
  if (name === "" || value === "") {
    throw new Error("设置cookie需要传入name 和 value");
  }
  const expire = new Date();
  expire.setTime(expire.getTime() + 3600000 * hour);
  document.cookie = `${name}=${value}; expires=${expire.toUTCString()}; path=${path}; domain=${domain || ""};`;
}
